import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { customObjectsLinkedToUserCacheKey } from "./constants";
import type { CustomObjectsLinkedToUserApiProps, CustomObjectsLinkedToUserResponse } from "./types";

export const getCustomObjectsLinkedToUser = reactQueryFetcherAdapter(
  customObjectsLinkedToUserCacheKey,
  (
    signal,
    { typeName, userIdentifier, pageNumber, pageSize }: CustomObjectsLinkedToUserApiProps
  ): Promise<CustomObjectsLinkedToUserResponse> => {
    return fetch<CustomObjectsLinkedToUserResponse>(
      `/custom_objects/${encodeURIComponent(typeName)}/linked_to_user/${encodeURIComponent(userIdentifier)}`,
      "GET",
      {
        page_number: pageNumber,
        page_size: pageSize,
      },
      { signal }
    );
  }
);
